import { isFunction, isString, memoize } from 'lodash'
import moment from 'moment'
import { ColumnSorter, Row, SortType } from 'types'

// the maximum number of moment dates we should memoize
// Once the cache size exceeds this value, we clear the cache
export const MAX_MEMOIZE_SIZE = 500000

export const toMoment: any = memoize((val: string, dateFormat: string) =>
  moment(val, dateFormat)
)

function createDateColumnSorter(
  columnKey: string,
  dateFormat: string
): ColumnSorter {
  const format = dateFormat || moment.ISO_8601
  return (a: Row, b: Row) => {
    const lhs = toMoment(a[columnKey], format)
    const rhs = toMoment(b[columnKey], format)
    return lhs.valueOf() - rhs.valueOf()
  }
}

function createColumnSorter(column: string): ColumnSorter {
  return (a: Row, b: Row) => {
    if (a[column] > b[column]) {
      return 1
    }
    if (a[column] < b[column]) {
      return -1
    }
    return 0
  }
}

export default {
  sort(
    rows: Row[],
    columnKey: string,
    ascending: boolean,
    sortType: string | ((column: string) => ColumnSorter) = '',
    defaultDateFormat: string = ''
  ): Row[] {
    let createSorter: (columnKey: string, dateFormat: string) => any
    if (isString(sortType) && sortType === SortType.Date) {
      createSorter = createDateColumnSorter
    } else if (isFunction(sortType)) {
      createSorter = sortType
    } else {
      createSorter = createColumnSorter
    }

    // console.time('sorting');
    const sortedRows = rows
      .slice()
      .sort(createSorter(columnKey, defaultDateFormat))
    // console.timeEnd('sorting');

    // console.log('cache size', toMoment.cache.size);
    if (toMoment.cache.size > MAX_MEMOIZE_SIZE) {
      toMoment.cache.clear()
    }

    // if not ascending, reverse the sorted data
    return ascending ? sortedRows : sortedRows.reverse()
  }
}
